import { UninstallAppBySupplierProvider } from '@/modules/utilities/uninstallApp/provider/UninstallAppBySupplierProvider.tsx'
import UninstallAppBySupplierModalContainer from '@/modules/utilities/uninstallApp/components/containers/UninstallAppBySupplierModalContainer.tsx'
import { useAppSelector } from '@/globalStore/hooks.ts'

const UninstallAppWrapper = () => {
  const { modalOpen } = useAppSelector((state) => state.uninstallApp)

  if (!modalOpen) return null

  return (
    <UninstallAppBySupplierProvider>
      <UninstallAppBySupplierModalContainer />
    </UninstallAppBySupplierProvider>
  )
}

export default UninstallAppWrapper
